import type { AnswerFragment } from '../../../present/activity-answers.graphql.generated';
import type { DrawAnswerFragment } from '../../../present/activity-answers.graphql.generated';
import { hasTextAnswer } from './has-text-answer';

export function hasAnswers(answers: AnswerFragment[] | undefined): boolean {
  if (!answers || answers?.length === 0) {
    return false;
  }

  return answers.some(answer => {
    if (answer.answerType === 'text-answer') {
      return hasTextAnswer(answer);
    } else if (answer.answerType === 'draw-answer') {
      return (answer.answer as DrawAnswerFragment).hasDrawingData;
    }
    return true;
  });
}
